export const HOUSE_SET_SCREEN = 'HOUSE_SET_SCREEN'
export const SET_ACTIVE_ICON = 'SET_ACTIVE_ICON'
export const LOAD_ICON_DETAIL = 'LOAD_ICON_DETAIL'
export const RESET_ZOOM = 'RESET_ZOOM'
export const SHOW_ICONS = 'SHOW_ICONS'
export const SHOW_MODAL = 'SHOW_MODAL'
export const SET_RESET_TRANSFORM_HOOK = 'SET_RESET_TRANSFORM_HOOK'
export const SET_JSON_DATA = 'SET_JSON_DATA'